import classNames from 'classnames';
import type { HTMLAttributes } from 'react';

export type StyledButtonGroupProps = HTMLAttributes<HTMLDivElement> & {
	justify?: 'space-between' | 'flex-start' | 'flex-end' | 'center';
	align?: 'flex-start' | 'flex-end' | 'center';
	direction?: 'horizontal' | 'vertical';
	wrap?: boolean;
	className?: string;
};

/**
 * Primary UI component for user interaction
 */
export const StyledButtonGroup = ({
	justify = 'space-between',
	direction = 'horizontal',
	align,
	wrap = false,
	...props
}: StyledButtonGroupProps) => {
	const buttonGroupClasses = classNames('styled-button-group', props.className);
	return (
		<div
			{...props}
			className={buttonGroupClasses}
			data-direction={direction}
			data-justify={justify}
			data-align={align}
			data-wrap={wrap ? 'wrap' : 'nowrap'}>
			{props.children}
		</div>
	);
};
